import React, { useState, useLayoutEffect, useContext } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Sector } from 'recharts';
import { ThemeContext } from 'styled-components';
import { icons } from '../../assets';
import mock from './mock';
import * as s from './styled-total-errors';

const TotalErros = ({ total }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [height, setHeight] = useState(window.screen.height);
  const [width, setWidth] = useState(window.screen.width);
  const { colors } = useContext(ThemeContext);

  const updateSize = () => {
    setHeight(document.getElementById('total-errors').clientHeight - 175);
    setWidth(document.getElementById('total-errors').clientWidth);
  };

  useLayoutEffect(() => {
    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const description = [
    {
      label: 'Vazão',
      color: colors.graphIntensity1,
      value: 1500,
    },
    {
      label: 'Temperatura',
      color: colors.graphIntensity2,
      value: 700,
    },
    {
      label: 'Pressão',
      color: colors.graphIntensity3,
      value: 600,
    },
    {
      label: 'Potência',
      color: colors.graphIntensity4,
      value: 550,
    },
    {
      label: 'Corrente',
      color: colors.graphIntensity5,
      value: 450,
    },
    {
      label: 'Vibração',
      color: colors.graphIntensity5,
      value: 300,
    },
    {
      label: 'Energia gerada',
      color: colors.graphIntensity5,
      value: 250,
    },
    {
      label: 'Fator de serviço',
      color: colors.graphIntensity5,
      value: 100,
    },
  ];

  const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    const {
      cx,
      cy,
      midAngle,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      percent,
      fill,
    } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const mx = cx + (outerRadius + 10) * cos;
    const my = cy + (outerRadius + 20) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 8;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';

    return (
      <g>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={outerRadius + 6}
          outerRadius={outerRadius + 10}
          fill={fill}
        />
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 3}
          y={ey}
          dy={12}
          textAnchor={textAnchor}
          fill={colors.darkerblue}
          style={{ fontWeight: 500, fontSize: '14px', zIndex: 10 }}
        >
          {`${(percent * 100).toFixed(2)}%`}
        </text>
      </g>
    );
  };

  const onPieEnter = (item, index) => setActiveIndex(index);

  const formatArray = (array) => {
    array.sort((a, b) => {
      if (a.value < b.value) return 1;
      return -1;
    });

    return array;
  };

  return (
    <s.Container id="total-errors">
      <s.Header>
        <label>Total de erros encontrados</label>
        <s.Icon src={icons.EngrenagemIcon} alt="configuração" />
      </s.Header>

      <ResponsiveContainer>
        <s.GraphContainer>
          <s.TotalErros>{total}</s.TotalErros>
          <PieChart width={width} height={height}>
            <Pie
              activeIndex={activeIndex}
              activeShape={renderActiveShape}
              data={mock.data}
              innerRadius="75%"
              outerRadius="80%"
              fill="#8884d8"
              onMouseEnter={onPieEnter}
              dataKey="value"
            >
              {mock.data.map((entry, index) => (
                <Cell
                  stroke="false"
                  key={entry.name}
                  fill={description[index].color}
                />
              ))}
            </Pie>
          </PieChart>
        </s.GraphContainer>
      </ResponsiveContainer>
      <s.DescriptionContainer>
        {formatArray(description).map((item, index) => (
          <s.Description
            key={item.label}
            title={item.label}
            selected={activeIndex === index}
            onMouseEnter={() => setActiveIndex(index)}
          >
            <s.Intensidade color={item.color} />
            <label>{item.label}</label>
          </s.Description>
        ))}
      </s.DescriptionContainer>
    </s.Container>
  );
};

export default TotalErros;
